import { Button, ButtonProps, Popover } from "antd";
import type { PopoverProps } from "antd";
import { RadiusIcon } from "components/icons/";
import { SettingSlider, SettingSliderProps } from "./SettingSlider";
import { useMemo } from "react";
import { useTranslate } from "@refinedev/core";

const MAX_RADIUS = 50;

export const BorderRadius = ({
  value,
  maxValue = MAX_RADIUS,
  onChange,
  buttonProps,
  popoverProps,
  relativeDimentions,
  popover = true,
  sliderProps,
}: {
  value: number;
  maxValue?: number;
  onChange: (value: number) => void;
  buttonProps?: ButtonProps;
  popoverProps?: PopoverProps;
  relativeDimentions: number;
  popover?: boolean;
  sliderProps?: SettingSliderProps;
}) => {
  const t = useTranslate();
  const roundedValue = useMemo(() => {
    return Math.round(value * relativeDimentions);
  }, [value, relativeDimentions]);

  const sliderComponent = () => (
    <SettingSlider
      label={t("components.templates.SettingsToolbar.controls.cornerRadius")}
      value={roundedValue}
      onChange={(value) => onChange(value / relativeDimentions)}
      max={maxValue}
      showValue={false}
      containerStyle={{
        flexDirection: "column",
        alignItems: "flex-start",
      }}
      style={{
        width: 150,
        margin: 0,
      }}
      {...sliderProps}
    />
  );

  if (!popover) {
    return sliderComponent();
  }

  return (
    <Popover
      trigger="click"
      placement="bottom"
      content={sliderComponent()}
      getPopupContainer={(triggerNode) =>
        triggerNode.parentElement ?? triggerNode
      }
      {...popoverProps}
    >
      <Button
        icon={<RadiusIcon />}
        type="text"
        size="small"
        data-testid="border-radius-button"
        {...buttonProps}
      />
    </Popover>
  );
};
